exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flash__game[data-v-3dbe36e4]{position:relative}", ""]);

// exports
